import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M4.703 21.638V10.753H3.088V5.542h5.171a1.3 1.3 0 0 1-.287-.55 2.7 2.7 0 0 1-.076-.643q0-1.12.785-1.907a2.6 2.6 0 0 1 1.907-.785q.575 0 1.065.241.491.241.877.646.387-.42.877-.653a2.44 2.44 0 0 1 1.065-.234q1.122 0 1.908.785.785.786.785 1.907 0 .333-.084.633t-.28.56h5.287v5.211h-1.616v10.885zm9.77-18.48q-.507 0-.85.342a1.15 1.15 0 0 0-.343.85q0 .505.343.849.342.343.85.343.505 0 .85-.343.342-.343.342-.85 0-.505-.343-.85a1.15 1.15 0 0 0-.85-.342M9.395 4.348q0 .507.342.85.343.343.85.343t.85-.343.342-.85q0-.505-.343-.85a1.15 1.15 0 0 0-.85-.342q-.505 0-.849.343a1.15 1.15 0 0 0-.342.85M4.588 7.042v2.211h7.25V7.042zm7.25 13.096v-9.385H6.203v9.385zm1.5 0h5.635v-9.385h-5.635zm7.25-10.885V7.042h-7.25v2.211z'
    />
  </svg>
)
export default SvgComponent
